import { render, staticRenderFns } from "./ffinfo.vue?vue&type=template&id=3bcd92c1&"
import script from "./ffinfo.vue?vue&type=script&lang=js&"
export * from "./ffinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports